@if (list && list.length > 0) {
  <span class="filter-title">{{ name | titlecase }}</span>
  <ul class="radio-select">
    @for (option of list; track option) {
      <li>
        <div class="radio-select__item">
          <div class="form-check" [ngClass]="{ active: option.checked }">
            <input
              type="checkbox"
              name="filter"
              class="form-check__input"
              [id]="option.value"
              [(ngModel)]="option.checked"
              (change)="getSelectedValue(option)"
            />
            <label class="form-check__label" [for]="option.value">
              <span>{{ option.label }}</span>
            </label>
          </div>
        </div>
      </li>
    }
  </ul>
}
